module.exports = __webpack_public_path__ + "img/2.66a65fe.png";